// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"Table_tableWrap__19z7p","mainTable":"Table_mainTable__3rmSU"};